import { Color } from '@diritto/common/style/color';
import { NewIconProps } from '@diritto/common/style/icon';
import { twMerge } from 'tailwind-merge';

export const ClockIcon = ({ className, color = Color.White }: NewIconProps) => (
  <svg
    className={twMerge(`size-[12px]`, className)}
    width="100%"
    height="100%"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_18159_2396)">
      <path
        d="M7.75978 8.44087L8.44239 7.77238L6.49023 5.80609V3.36587H5.58478V6.17523L7.75978 8.44087ZM6.00098 11.1767C5.28873 11.1767 4.61814 11.0411 3.98919 10.7698C3.36025 10.4985 2.81107 10.1283 2.34166 9.65902C1.87225 9.18979 1.50184 8.64081 1.23045 8.01211C0.95906 7.38341 0.823364 6.713 0.823364 6.00088C0.823364 5.28877 0.959523 4.61798 1.23184 3.98851C1.50415 3.35904 1.87429 2.81032 2.34225 2.34236C2.81022 1.87439 3.35871 1.50307 3.98774 1.22841C4.61676 0.953739 5.28752 0.816406 6 0.816406C6.71248 0.816406 7.38324 0.953739 8.01226 1.22841C8.64129 1.50307 9.18979 1.87439 9.65775 2.34236C10.1257 2.81032 10.497 3.35882 10.7717 3.98784C11.0464 4.61687 11.1837 5.28762 11.1837 6.00011C11.1837 6.71259 11.0464 7.38334 10.7717 8.01237C10.497 8.64139 10.1257 9.18989 9.65775 9.65786C9.18979 10.1258 8.64139 10.496 8.01258 10.7683C7.38375 11.0406 6.71322 11.1767 6.00098 11.1767ZM5.9964 10.1865C7.14663 10.1865 8.13252 9.77809 8.95408 8.96124C9.77563 8.1444 10.1864 7.15854 10.1864 6.00364C10.1864 4.84875 9.77595 3.8617 8.95501 3.04249C8.13408 2.22329 7.1491 1.81369 6.00006 1.81369C4.84749 1.81369 3.8616 2.22301 3.04239 3.04163C2.22319 3.86025 1.81359 4.84641 1.81359 6.00011C1.81359 7.15736 2.22317 8.1444 3.04233 8.96124C3.86149 9.77809 4.84619 10.1865 5.9964 10.1865Z"
        fill={color}
      />
    </g>
    <defs>
      <clipPath id="clip0_18159_2396">
        <rect width="100%" height="100%" fill={color} />
      </clipPath>
    </defs>
  </svg>
);
